/**
 * Normaliza un nombre o apellidos: recorta los extremos y colapsa
 * cualquier secuencia de espacios en blanco en un único espacio.
 */
export const normalizeName = (value) => String(value ?? '').replace(/\s+/g, ' ').trim()
